module.exports = __webpack_public_path__ + "img/ro.af9e2aae.svg";